import { TableType } from './externalProperty';

export enum AsynchronousOperationStatus {
  Started = 'Started',
  OnGoing = 'OnGoing',
  Completed = 'Completed',
  CompletedWithErrors = 'CompletedWithErrors',
}

export interface CrmPush {
  id: number;
  status: AsynchronousOperationStatus;
  tableType: TableType;
  startDate: Date;
  endDate: Date | null;
  quantity: number;
  okQuantity: number;
  warningQuantity: number;
  warnings?: string[] | null;
  crmPushPairs: CrmPushPair[];
}

export interface CrmPushPair {
  oldObjectId: string;
  newObjectId?: string;
  tableType: TableType;
  primary: boolean;
}
